import { reactive } from "vue";
import { CurrentUserModel } from "./models";

const currentUserSymbolKey = Symbol.for("currentUser");

const _window = window as any;
let currentUser = _window[currentUserSymbolKey];
if (!currentUser) {
  currentUser = new CurrentUserModel();
  _window[currentUserSymbolKey] = currentUser;
}

export const CurrentUser = reactive<CurrentUserModel>(currentUser);
